<template>
  <div class="topbar-item h-100">
    <template>
      <modal
          :width="1000"
          :height="800"
          :adaptive="true"
          :scrollable="false"
          style="overflow-y: auto"
          name="loginHistory">
        <section class="p-3" style="height: 800px; overflow: scroll">
          <b-table striped hover :items="loginHistory"></b-table>
        </section>
      </modal>
    </template>
    <div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg" id="kt_quick_user_toggle">
      <span class="text-dark-50 font-weight-bolder font-size-xs d-none d-md-inline mr-3">
        {{loginUser.email}}
      </span>
    </div>

    <div id="kt_quick_user" ref="kt_quick_user" class="offcanvas offcanvas-right p-10" >
      <!--begin::Header-->
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-5">
<!--
        <h3 class="font-weight-bold m-0">
          User Profile
          &lt;!&ndash;<small class="text-muted font-size-sm ml-2">12 messages</small>&ndash;&gt;
        </h3>
        -->
        <div>
          <button class="btn btn-light-primary btn-bold d-inline-block mr-5" @click="onLogout">
            Sign out
          </button>
          <!-- user정보변경, edit password -->
          <!--
          <button @click="goEditUserProfile()" class="btn btn-light-danger btn-bold d-inline-block">
            Edit user profile
          </button>
          -->

        </div>
        <a href="#" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_user_close">
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>

      <b-card>

        <perfect-scrollbar
            class="offcanvas-content pr-5 mr-n5 scroll"
            style="position: relative;"
        >
          <span class="d-flex align-items-center">
            <h5>
            Account Info
            </h5>
            <div class="d-flex ml-25">
              <b-form-checkbox v-on:change="emailNotificationChange" v-model="emailNotification" name="check-button" switch />
              <i v-if="emailNotification" class="flaticon-alert text-info"></i>
              <i v-if="!emailNotification" class="flaticon-alert-off text-success"></i>
            </div>
          </span>



          <div class="d-flex align-items-center mt-1">
            <div class="d-flex flex-column w-100">
              <div class="navi mt-2">
                <a href="#" class="navi-item">
              <span class="navi-link p-0 pb-2">
                <span class="navi-icon mr-1">
                  <span class="svg-icon svg-icon-lg svg-icon-primary text-muted">
                    <h2><b-icon-envelope></b-icon-envelope></h2>
                    <!--begin::Svg Icon-->
                    <!--
                    <inline-svg
                            src="media/svg/icons/Communication/Mail-notification.svg"
                    />
                    -->

                    <!--end::Svg Icon-->
                  </span>
                </span>

                <span class="navi-text text-muted text-hover-primary">
                  {{loginUser.email}}
                </span>
              </span>
                </a>
              </div>
              <div class="navi my-2">
                <a href="#" class="navi-item">
                  <span class="navi-link p-0 pb-2">
                    <span class="navi-icon mr-1">
                      <span class="svg-icon svg-icon-lg svg-icon-primary text-muted">
                        <!--begin::Svg Icon-->
                        <h2><b-icon-phone></b-icon-phone></h2>
                        <!--end::Svg Icon-->
                      </span>
                    </span>
                    <span class="navi-text text-muted text-hover-primary">
                      {{loginUser.phoneNumber}}
                    </span>
                  </span>
                </a>
              </div>
              <div class="navi my-2">
                <TimeFormatSelector/>
              </div>

              <div v-show="!role.isUserDashboard">
                <a v-show="isCheckOtpAuth" class="text-primary cursor-pointer" @click="resetOtp()">
                  <span>
                    <b-icon icon="key-fill"></b-icon>
                    disable 2 step verification</span>
                </a>

                <a v-show="!isCheckOtpAuth" class="text-primary cursor-pointer" @click="goSettingOtp()">
                  <span>
                  <b-icon icon="key-fill"></b-icon>
                  2 step verification</span>
                </a>
              </div>





              <!--
              <button class="btn btn-light-primary btn-bold mb-5" @click="onLogout">
                Sign out
              </button>
              <button class="btn btn-light-danger btn-bold" @click="onChangePassword">
                Password Change
              </button>
              -->
            </div>
          </div>

          <div class="separator separator-dashed my-3"></div>


          <div>

            <!--begin:Heading-->
            <h5 class="mb-5">Project Info</h5>
            <!--end:Heading-->
            <template>
              <!--begin::Item -->
              <div class="d-flex align-items-center rounded p-5 gutter-b bg-light-warning">
                <div class="d-flex flex-column flex-grow-1 mr-2">
                <span class="font-weight-bolder py-1 font-size-lg text-warning">
                  Current Selected Project
                </span>
                <span class="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1">
                  {{$isEmptyObject( projectObject ) ? "-" : projectObject.name}}
                </span>
                </div>

              </div>


              <!--두번째 시작-->
              <div v-if="projectIdList.length > 1 || role.isUserDashboard ">
                <div class="d-flex align-items-center rounded p-5 gutter-b bg-light-success cursor-pointer">
                  <div class="d-flex flex-column flex-grow-1 mr-2">
                  <span class="font-weight-bolder py-1 font-size-lg text-success" @click="goProjectList">
                    Other Projects
                    <b-icon icon="box-arrow-right"></b-icon>
                  </span>
                    <!--                <span href="#" class="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1" style="word-break: break-all;">https://form.jotform.com/200701654058449</span>-->
                  </div>

                </div>
              </div>

              <!-- 두번째 종료 -->

              <!--세번째 종료-->
              <div class="d-flex align-items-center rounded p-5 gutter-b bg-light-primary cursor-pointer">
                <div class="d-flex flex-column flex-grow-1 mr-2">
                  <span class="font-weight-bolder py-1 font-size-lg text-primary" @click="openLoginHistory">
                    User History
                    <b-icon icon="box-arrow-right"></b-icon>
                  </span>
                  <!--                <span href="#" class="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1" style="word-break: break-all;">https://form.jotform.com/200701654058449</span>-->
                </div>
              </div>



              <!--end::Item -->
            </template>
          </div>
        </perfect-scrollbar>
        <!--end::Header-->
      </b-card>
        <b-button v-show="currentUser.isMadeFreeProject === false" variant="primary" :disabled="isLoading" class="w-100 mt-3" @click="createTrialProject">
          {{isLoading ? "Loading..." : "Create Trial Project"}}
        </b-button>


    </div>
  </div>
</template>

<style lang="scss" scoped>
  #kt_quick_user {
    overflow: hidden;
  }
</style>

<script>
  import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
  import KTOffcanvas from "@/assets/js/components/offcanvas.js";
  import {API, Auth} from 'aws-amplify';


  import {mapGetters, mapState} from 'vuex';
  import TimeFormatSelector from "@/view/layout/extras/offcanvas/TimeFormatSelector.vue";

  export default {
    name: "KTQuickUser",
    components: {TimeFormatSelector},
    data() {
      return {
        isLoading : false,
        isExistOtherProject : false,
        loginHistory : [],
        emailNotification: true,

      };
    },

    async mounted() {

      // Init Quick User Panel
      KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);


      let param = {email: this.email};

      try {
        let auth = await this.$store.dispatch('getProjectAdmins', param);

        if (auth.statusCode === 200 && auth.emailNotification !== undefined) {
          this.emailNotification = auth.emailNotification;
        } else {
          this.emailNotification = true;
        }
      } catch (e) {
        console.log(e);
      }



    },
    methods: {
      async createTrialProject() {
        try {
          const confirm = await this.$swal({
            icon: 'question',
            text: this.$t('CreateTrialProject'),
            showCancelButton: true
          });
          if (!confirm.isConfirmed) return;

          this.isLoading = true;
          const createTrialProjectResponse = await API.post('apiArgosDashboard', '/addProject', {
            body: {
              alias : this.$store.getters.getEnv,
              admin : this.currentUser.email
            }
          });
          if (createTrialProjectResponse.statusCode === 200) {
            this.$swal({
              icon : 'success',
              text : this.$t("Success")
            }).then(() => window.location.reload())
          } else {
            return this.$swal({
              icon: 'error',
              text: 'Something went wrong, Please Retry.',
            })
          }
        } catch (e) {
        } finally {
          this.isLoading = false;
        }
      },

      async callResetOtp () {
        let params = {
          email: this.loginUser.email
        };
        let resetOtpValue = await this.$store.dispatch('resetOtp', params);
        console.log("resetOtpValue", resetOtpValue);
        if( resetOtpValue.statusCode === 200 ) {
          await this.$store.dispatch( "setIsCheckOtpAuth", false );
        }
      },
      async resetOtp(){

        this.$swal( {
          icon : 'question',
          text : 'Are you sure you want to disable 2 step verification?',
          showCancelButton: true
        } ).then( ( res ) => {

          if( res.isConfirmed ) {
            this.callResetOtp();
          }
        })

      },

      goSettingOtp() {

        this.closeOffcanvas();

        if( this.$route.name !== "setting-otp" ) {
          this.$router.push( {name : 'setting-otp'} );
        }
      },
      goProjectList() {

        this.closeOffcanvas();

        let currUrl = this.$router.currentRoute.fullPath;
        if( currUrl.includes( "project-list" ) ) {
          return;
        }

        this.$router.push({name: 'project-list'});
      },

      //  go edit user
      goEditUserProfile() {

        this.closeOffcanvas();

        let currUrl = this.$router.currentRoute.fullPath;
        if( currUrl.includes( "edit-user-profile" ) ) {
          return;
        }
        //this.$router.push({ name: 'kyb-detail', params: {id: item.submission_id, email: item.email}});
        this.$router.push({ name: 'edit-user-profile', key: this.$router.fullPath} );
      },

      async onLogout() {
        console.log( "logout 실행 ::: " )

        this.$session.clear();
        window.sessionStorage.removeItem( "vuex" )

        try {
          await Auth.signOut();
        } catch (error) {
          console.log('error signing out: ', error);
        }

        location.href="/";
        /*
                this.$store
                .dispatch(LOGOUT)
                .then(() => this.$router.push({ name: "login" }));
         */
      },

      async emailNotificationChange() {
        console.log( "emailNotificationChange 실행 ::: " + this.emailNotification )


        let payload = {
          emailNotification : this.emailNotification
        }
        await this.$store.dispatch( "emailNotification", payload );
      },

      async openLoginHistory() {
          const loginHistoryRes = await this.$store.dispatch('getLoginHistory')

          const mergingUTCIntoCreateTime = `createTime (UTC${this.$store.getters.getSelectedLang.utc})`
          const generateHistory = (historyArray) => {
            return historyArray.map((item) => {
              const {uuid, createTime, ...rest} = item;

              const returnObj = {
                [mergingUTCIntoCreateTime]: this.$changeTimeFromSelectedLang(item.createTime, this.$store.getters.getSelectedLang),
                ...rest
              }
              return returnObj
            })
          }
          let excludeUUID = [];

          if (Array.isArray(loginHistoryRes)) {
              excludeUUID = generateHistory(loginHistoryRes);
          } else {
              excludeUUID = generateHistory(loginHistoryRes.Items);
          }

          this.loginHistory = excludeUUID
          this.$modal.show("loginHistory");
      },

      closeOffcanvas() {
          new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
      },


      save(){
        this.$swal( {
          icon : 'success',
          text : 'Success',
          showCancelButton: false
        } ).then( ( ) => {
          this.closeOffcanvas();
        })
      }

    },
    computed: {
      ...mapState(["email"]),

      ...mapGetters( {
        role : "getUserRole",
        isCheckOtpAuth : "isCheckOtpAuth",
        loginUser : "currentLoginUser",
        projectObject : "getSelectedProjectObject",
        projectIdList : "getProjectSimpleInfoList",
        currentUser : "currentLoginUser",
      } ),
    },
  };
</script>
